import { isString, isBoolean, isArray } from 'lodash';
import { serializeContactName } from './general';
import { serializeChainType } from './chain';

export const serializeChainTypes = types =>
  types.map(type => serializeChainType(type));

export const serializeMessengerTypes = messengers =>
  messengers.map(messenger => ({
    type: messenger.transport,
    active: messenger.active,
  }));

export function serializeClient(client) {
  if (!client) {
    return null;
  }

  const {
    email,
    full_name: fullName,
    is_new: isNew,
    deleted_at: deletedAt,
    is_segment_allowed: isSegmentAllowed,
    name,
    // partner_id: partnerId,
    sub_agent_name: subAgentName,
    person_id: personId,
    person_type: unparsedPersonType,
    phone: unparsedPhone,
    surname,
    patronymic,
    messengers,
    label_ids: labelIds,
  } = client;

  const phone = isString(unparsedPhone) ? unparsedPhone : null;
  const personType = isString(unparsedPersonType)
    ? unparsedPersonType
    : 'client';
  return {
    avatarUrl:
      !isString(client.avatar_url) ||
      client.avatar_url === 'client_auth/default_avatar@2x.jpg'
        ? null
        : client.avatar_url, // TODO: Will fix on backend
    email: isString(email) ? email : null,
    fullName: serializeContactName(fullName, phone, personType),
    id: String(personId),
    isDeleted: !!deletedAt,
    isNew: isBoolean(isNew) ? isNew : null,
    isSegmentAllowed: isBoolean(isSegmentAllowed) ? isSegmentAllowed : false,
    name: isString(name) ? name : null,
    isPartnerClient: !!subAgentName,
    phone,
    surname: isString(surname) ? surname : null,
    patronymic: isString(patronymic) ? patronymic : null,
    type: personType,
    messengers: isArray(messengers)
      ? serializeMessengerTypes(messengers)
      : null,
    labelIds,
  };
}

export function serializeClients(clients) {
  if (!isArray(clients) && clients.length < 1) return null;

  return clients.map(client => serializeClient(client));
}
